import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { PriceStore } from '../../../stores/PriceStore';
import { UIHelper } from '../../../utils/UIHelper';
import { Price } from '../../Price';
import { AppConfigurationStore } from '../../../stores/AppConfigurationStore';
import { ProjectSettingsStore } from '../../../stores/ProjectSettingsStore';

import eaiws = egr.wcf.eaiws;
import utils = egr.wcf.utils;
import { ArticleItem } from '../../../stores/ArticleStore';

export interface ArticleListItemData {
    properties: eaiws.basket.ItemProperties;
    image: string;
}

interface ArticleListItemProps extends React.Props<ArticleListItem> {
    itemData: ArticleItem;
    showPrices: boolean;
    inconsistencies: Array<string>;
}

const quantity: number = 1;

export class ArticleListItem extends BaseComponent<ArticleListItemProps, {}> {
    // Note: this function has to be static in order to use it inside of
    // the ArticleList component render function
    public static getPrice(itemProperties: eaiws.basket.ItemProperties): number {
        if (
            itemProperties.article == null ||
            itemProperties.article.salesPrice == null ||
            utils.string.isNullOrEmpty(itemProperties.article.currency)
        ) {
            return 0;
        }
        return quantity * PriceStore.getPrice(itemProperties.article.salesPrice, itemProperties.article.currency);
    }

    public render(): JSX.Element {
        const data: ArticleItem = this.props.itemData;
        const price: number = ArticleListItem.getPrice(data.properties);
        let articlePriceDiv: JSX.Element | null = null;
        if (
            this.props.showPrices &&
            data.properties.article != null &&
            utils.string.isNotNullOrEmpty(data.properties.article.currency)
        ) {
            const currency: string | undefined = PriceStore.isCurrencyValid(data.properties.article.currency) ?
            ProjectSettingsStore.getState().currency : data.properties.article.currency;

            articlePriceDiv = (
                <div className="article-position-price">
                    <div className="article-price-quantity">{t('Unit price')}</div>
                    <div className="article-price-sum">
                        <Price value={price} currency={currency} />
                    </div>
                </div>
            );
        }
        return (
            <div
                className={
                    'article-list-position' + (this.props.showPrices ? ' with-price' : '') +
                    (this.props.inconsistencies.length ? ' inconsistencies' : '')
                }
            >
                <div className="article-position-header">
                    <div className="article-image" style={{ backgroundImage: 'url(' + data.image + ')'}}/>
                    <div className="article-header">{UIHelper.getArticleHeader(data.properties, AppConfigurationStore.getState().showArticleNumbers)}</div>
                </div>
                {this.longtext(data)}
                <ul className="article-position-featuretext">
                    {this.featureTextArray(data.properties).map((item: any): JSX.Element | null => {
                        if (item.text) {
                            return (
                                <li key={item.id}>{item.text}</li>
                            );
                        }
                        return null;
                    })}
                </ul>
                {articlePriceDiv}
                {this.props.inconsistencies.map((text: string, index: number) => {
                    return (
                        <div key={'inconsistency-' + index.toString()} className="inconsistency">{text}</div>
                    );
                })}
            </div>
        );
    }

    protected longtext = (data: ArticleItem): JSX.Element | null => {
        if (data.properties.article == null || utils.string.isNullOrEmpty(data.properties.article.longText)) {
            return null;
        }

        return (
            <div className="article-position-longtext">
                {UIHelper.multilineTextToArray(data.properties.article.longText).map((line: string, index: number) => {
                    return (
                        <div key={index}>{line}</div>
                    );
                })}
            </div>
        );
    };

    protected manufacturerHeader(data: eaiws.basket.ItemProperties): string {
        if (data.article == null) {
            return '';
        }
        const outputArray: Array<string> = [];
        if (utils.string.isNotNullOrEmpty(data.article.manufacturerName)) {
            outputArray.push(data.article.manufacturerName);
        }
        if (utils.string.isNotNullOrEmpty(data.article.seriesId)) {
            outputArray.push(data.article.seriesId);
        }

        return outputArray.join(' | ');
    }

    // Each child in an array or iterator should have a unique "key" prop.
    protected featureTextArray(data: eaiws.basket.ItemProperties): Array<{text: string, id: string}> {
        const result: Array<{text: string, id: string}> = [];
        if (data.article != null && data.article.featureText != null) {
            const tDate: Date = new Date();
            const tIdBase: string = tDate.getTime().toString();
            UIHelper.multilineTextToArray(data.article.featureText).map((item: string): void => {
                const tId: string = tIdBase + '_' + result.length.toString();
                result.push({text: item, id: tId});
            });
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/articlelist/ArticleListItem.tsx